import React from 'react';
import { useTranslation } from 'react-i18next';

import type { RouterItem } from '@/types/RouterItem';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';
import PageHeader from '@/components/pageheaders/PageHeader';
import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import useLayout from '@/hooks/useLayout';

const AccountHeader: React.FC = () => {
  const { t } = useTranslation();
  const { selectedFleetAccount, isLoading, fleetVerifiedUnits } = useFleetAccount();
  const { canShowDashboard } = useLayout({
    units: fleetVerifiedUnits,
    unitsLoading: isLoading,
  });

  const items: RouterItem[] = [
    {
      title: t(($) => $.pages.account.tabs.dashboard),
      to: '/dashboard',
      hide: !canShowDashboard,
      children: [
        {
          title: t(($) => $.pages.account.dashboard.active_fault_codes.title),
          to: '/dashboard/active-fault-codes',
        },
        {
          title: t(($) => $.pages.account.dashboard.connectivity.title),
          to: '/dashboard/connectivity',
        },
        {
          title: t(($) => $.pages.account.dashboard.fuel_consumption.title),
          to: '/dashboard/fuel-consumption',
        },
      ],
    },
    {
      title: t(($) => $.pages.account.tabs.unit_overview),
      to: '/units',
    },
    {
      title: t(($) => $.pages.account.tabs.fleet_overview),
      to: '/fleets',
    },
    {
      title: t(($) => $.pages.account.tabs.campaigns),
      to: '/campaigns',
    },
    {
      title: t(($) => $.pages.account.tabs.members),
      to: '/members',
    },
  ];

  return (
    <PageHeader isLoading={isLoading} title={selectedFleetAccount?.name ?? 'Default fleet account'} items={items} />
  );
};

export default withComponentErrorBoundary(AccountHeader);
